module.exports = __webpack_public_path__ + "img/020074.855001e6.png";